import { TopBar as KitTopBar } from '@cinesend/ui-kit'
import Transfers from '../transfers'

function TopBar() {
  return (
    <KitTopBar>
      <Transfers />
    </KitTopBar>
  )
}

export default TopBar
